import { useState, useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AuthContext } from "../../../context/authContext";
import { makeRequest } from "../../../utils/axios.js"; 
import upload from "../../../lib/uploadDatabase";

export const useShare = () => {
    const [openModal, setOpenModal] = useState(false);
    const { currentUser } = useContext(AuthContext);
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: (newPost) => makeRequest.post("/posts", newPost),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["posts"] });
            setOpenModal(false);
        },
        onError: (error) => {
            console.error("Error creating post:", error);
            alert("An error occurred while posting.");
        },
    });

    const handleShareSubmit = async (postDesc, postFiles, postType, linkPreview) => {
        if (!postDesc && postFiles.length === 0) return;

        let imgUrls = [];

        if (postFiles.length > 0) {
        imgUrls = await upload(postFiles);
        }

        mutation.mutate({
        desc: postDesc,
        img: imgUrls,
        type: postType,
        linkUrl: linkPreview?.url || null,
        linkTitle: linkPreview?.title || null,
        linkDesc: linkPreview?.description || null,
        linkImg: linkPreview?.img || null,
        });
    };

    return {
        openModal,
        setOpenModal,
        currentUser,
        handleShareSubmit,
    };
};